export default {
  Desktop: 'Desktop',
  Hello: 'Hello',
  Update_notice: 'Update notice',
  Quota: 'Quota',
  As_of_the_date: 'As of the date',
  beijing_time: 'Beijing time UTC+8',
  pacific_time: 'Pacific time UTC-7',
  store_authorization: 'Store authorization',
  sku_archives: 'SKU archives',
  order_process: 'Order process',
  exam_stock_out: 'Exam & stockout',
  exam_stock_in: 'Exam & stockin',
  purchase_order: 'Purchase order',
  warehouse_management: 'Warehouse management',
  collection_and_payment: 'Collection and payment',
  order_distribution: 'Order distribution (last day)',
  Daily_order_quantity: 'Daily order quantity',
  sales_trend: 'Sales trend',
  Tips: 'Tips',
  sales_trend_tooltip: 'Cash on delivery orders are calculated according to the order place time, other orders are by payment time. The profit are projected',
  cross_border_ERP: '旺店通跨境ERP',
  Updates: 'Updates',
  key_function: 'key functions',
  No_more_reminder: 'No more reminder',
  learn_more: 'learn more',
  Got_it: 'Got it',
  seven_day: '7-day',
  thirty_day: '30-day',
  custom: 'custom',
  Sign_out: 'Sign out',
  purchase_refund_order: 'purchase_refund_order',
  version: 'version',
  changePasswd: 'change password',
}
